import React from 'react'
import IconWithBackground from '../IconWithBackground/IconWithBackground'
import { OrderMessageThread } from '../../model'
import { formatDate, formatTime, isToday, isYesterday } from '../../helpers/utils'
import { NavLink } from 'react-router-dom'
import Avatar from '../Avatar/Avatar'
import { sanitizeHtml } from '../../helpers/sanitizer'

export interface MessageItemProps {
    data: OrderMessageThread
    isSelected?: boolean
    onOrderDetail?: boolean
}

const MessageItem: React.FunctionComponent<MessageItemProps> = ({
    data,
    isSelected,
    onOrderDetail
}: MessageItemProps) => {
    const orderPerson = data.concerns

    const getTimeOfLastMessage = () => {
        if (!data.lastMessage?.date) {
            return null
        }

        if (isToday(data.lastMessage.date)) {
            return formatTime(data.lastMessage.date)
        } else if (isYesterday(data.lastMessage.date)) {
            return 'Gisteren'
        } else {
            return formatDate(data.lastMessage.date)
        }
    }

    const redirectTo = onOrderDetail
        ? `?selectedThread=${data.id}`
        : `/dashboard/orders/order/${data.order.id}/messages?selectedThread=${data.id}`
    const truncateText = `truncate max-w-64 md:max-w-44`

    const messageIsIframe = data.lastMessage?.message?.toString().includes('<iframe')
    const lastMessage = messageIsIframe ? data.lastMessage?.message : sanitizeHtml(data.lastMessage?.message)

    return (
        <NavLink
            to={redirectTo}
            className={`${
                isSelected ? 'bgLinkColor bg-opacity-5' : 'bg-white'
            } flex w-full hover:bg-gray-50 relative justify-between items-start border-top first:border-t-0 pb-2 pt-6 px-3`}
        >
            <div className='flex flex-shrink-0 justify-center'>
                {
                    // @ts-ignore
                    data?.order?.icon ? (
                        <IconWithBackground
                            iconName={
                                // @ts-ignore
                                data?.order?.icon
                            }
                        />
                    ) : (
                        <Avatar name={orderPerson} invert />
                    )
                }
            </div>

            <div className='flex-grow overflow-hidden'>
                <div className='flex flex-col flex-grow flex-shrink overflow-hidden pl-2 gap-y-1 pr-12'>
                    {!onOrderDetail ? (
                        <>
                            <h3 className={`font-medium text-sm pr-8 ${truncateText}`}>
                                {data.order.address}, {data.order.zipcode} {data.order.city}
                            </h3>
                            {data.order.title && (
                                <span className={`text-[--tb-text] text-xs ${truncateText}`}>{data.order.title}</span>
                            )}
                            <div className={`text-xs font-semibold ${truncateText}`}>
                                <span className='text-[--tb-text]'>betreffende </span>
                                <span className='text-[--tb-linkColor]'>{orderPerson}</span>
                            </div>
                        </>
                    ) : (
                        <h3 className={`font-medium text-sm pr-8 ${truncateText}`}>{orderPerson}</h3>
                    )}
                    <p className={`text-[--tb-text] text-xs italic ${truncateText}`}>
                        {lastMessage || '<Geen bericht>'}
                    </p>
                </div>

                <div className='absolute flex flex-col justify-end items-end gap-y-2 right-4 top-2 text-right'>
                    <span className='text-[0.7rem] opacity-70'>{data.lastMessage?.date && getTimeOfLastMessage()}</span>

                    {data.unreadCount !== undefined && data.unreadCount > 0 && (
                        <span className='bgPrimaryColor ccText text-[10px] w-4 h-4 flex items-center justify-center rounded-full bg-opacity-100'>
                            {data.unreadCount}
                        </span>
                    )}
                </div>
            </div>
        </NavLink>
    )
}

export default MessageItem
